function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteDecommissioned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-5",
    width: 21.166666,
    height: 21.166666,
    x: -5.5511151e-17,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d4ae26",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0",
    width: 18.520834,
    height: 18.520834,
    x: 1.3229064,
    y: 277.15622,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.230039
    },
    d: "m 10.583332,280.33124 c -2.0457533,0 -3.7041654,1.77707 -3.7041654,3.96894 0,3.34943 3.7041654,7.93731 3.7041654,7.93731 0,0 3.704168,-4.68237 3.704168,-7.93731 0,-2.19187 -1.658412,-3.96894 -3.704168,-3.96894 z m 0,2.23243 a 1.7779999,1.7859364 0 0 1 1.778,1.78593 1.7779999,1.7859364 0 0 1 -1.778,1.78594 1.7779999,1.7859364 0 0 1 -1.7779989,-1.78594 1.7779999,1.7859364 0 0 1 1.7779989,-1.78593 z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d4ae26",
      fillOpacity: 1,
      strokeWidth: 0.559969
    },
    id: "rect859",
    width: 14.552083,
    height: 3.96875,
    x: 3.3072917,
    y: 284.43228
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.382532
    },
    id: "rect859-1",
    width: 14.552083,
    height: 1.8520833,
    x: 3.3072917,
    y: 285.4906
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteDecommissioned);
export default __webpack_public_path__ + "static/media/icon-site-decommissioned.e339b5f177ddea61cee850653b5cfb01.svg";
export { ForwardRef as ReactComponent };